module.exports = __webpack_public_path__ + "img/1 - Copy.a3144519.png";